import cx from 'classnames';
import PropTypes from 'prop-types';

import magnifier from '../../images/magnifier.svg';
import * as style from './searchicon.module.scss';
import TabButton from './tabbutton';

const SearchIcon = ({ className, closingSearch, openSearch }) => {
  return (
    <TabButton
      aria-label="Open search"
      className={cx(style.searchIcon, className)}
      onClick={openSearch}
      ref={(button) => closingSearch && button?.focus()}
      size="small"
      theme="light"
    >
      <img alt="" src={magnifier} />
    </TabButton>
  );
};

SearchIcon.propTypes = {
  className: PropTypes.string,
  closingSearch: PropTypes.bool,
  openSearch: PropTypes.func.isRequired,
};

export default SearchIcon;
